// extracted by mini-css-extract-plugin
export default {"container":"lU-z","modal":"mU-z","dimensions":"nU-z","brandName":"oU-z","productName":"pU-z","recipientEmail":"qU-z","recommendedFit":"rU-z","hiddenField":"sU-z"};